import { AxiosResponse } from "axios";
import { TFunction } from "i18next";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { FileUpload } from "primereact/fileupload";
import { Toast } from "primereact/toast";
import React, { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { SeverityEnum } from "../../shared/enum/SeverityEnum";
import { FileUtils } from "../../shared/utils/FileUtils";
import { AdminRequirementsService } from "../services/AdminRequirementsService";
import { RichText } from "prismic-reactjs";
import { FormService } from '../../form/services/FormService';

interface Props extends WithTranslation {
}

interface States {
}

class AdminRequirements extends Component<Props, States> {
  private readonly requirementService: AdminRequirementsService;
  private toast: Toast | null;
  private fileUpload: FileUpload | null;
  private t: TFunction;
  private formService: FormService;

  constructor(props: Props) {
    super(props);
    this.requirementService = new AdminRequirementsService();
    this.formService = new FormService();
    this.t = this.props.t;
    this.toast = null;
    this.fileUpload = null;
  }

  /**
   * On upload
   */
  handleUpload(e: { files: File[] }) {
    if (!e.files) {
      return;
    }
    this.requirementService
      .uploadRequirements(e.files[0])
      .then(() => {
        this.toast?.show({
          severity: SeverityEnum.SUCCESS,
          detail: this.formService.t(this.t, "ui_admin_requirements_toast_success", false),
        });
        this.fileUpload?.clear();
      })
      .catch((err: any) => {
        const message = err?.response?.data?.message;
        this.toast?.show({
          severity: SeverityEnum.ERROR,
          detail: `${this.formService.t(this.t, "ui_admin_requirements_toast_error", false)} : ${message}`,
        });
      });
  }

  /**
   * On download
   */
  handleDownload() {
    this.requirementService.downloadRequirements().then((response: AxiosResponse<Blob>) => {
      FileUtils.downloadFile(response);
    });
  }

  render() {
    return (
      <Card title={RichText.asText(this.t("ui_admin_requirements_title", { returnObjects: true }))}>
        <Toast ref={(el) => (this.toast = el)}/>
        <Button
          label={RichText.asText(this.t("ui_admin_requirements_download_button", { returnObjects: true }))}
          className="p-mb-2"
          onClick={() => this.handleDownload()}
        />
        <FileUpload
          ref={(el) => (this.fileUpload = el)}
          accept="application/json"
          customUpload={true}
          uploadHandler={(e: { files: File[] }) => this.handleUpload(e)}
        ></FileUpload>
      </Card>
    );
  }
}

export default withTranslation()(AdminRequirements);
